import React from 'react'
import Page from 'contexts/page'
import Routing from './routing'
import UpgradeCTA from 'components/upgrade-cta'

const SalaryPage = ({ upgradable, ...props }) => {
    const salt = 'salary'

    return (
        <Page
            view="salary"
            title={{
                id: 'noun_salary',
                defaultMessage: 'Salary'
            }}
            upgrade={{
                enabled: upgradable,
                content: (
                    <UpgradeCTA
                        module="salary"
                        responsive
                        useUpgradeIcon
                        useFeatureOrModuleIcon
                        className="compact"
                        salt={`upgrade:${salt}`} />
                )
            }}>
            <Routing
                {...props}
                upgradable={upgradable} />
        </Page>
    )
}

export default SalaryPage